// The search dropdown's default panel is fetched the first time search is
// opened rather than shipped in every page's HTML. header-search renders twice,
// mobile and desktop, so this promise is shared: one request fills both slots.
let searchPanelRequest = null;

function fetchSearchPanel() {
  if (!searchPanelRequest) {
    searchPanelRequest = fetch(`${window.Shopify.routes.root}?section_id=search-panel`)
      .then((response) => (response.ok ? response.text() : Promise.reject(response.status)))
      .then((text) => {
        const panel = new DOMParser().parseFromString(text, 'text/html').querySelector('.predictive-search-empty');
        if (!panel) throw new Error('search panel missing from response');
        return panel.innerHTML;
      })
      .catch((error) => {
        // Clear it so the next open tries again rather than caching the failure.
        searchPanelRequest = null;
        throw error;
      });
  }
  return searchPanelRequest;
}

class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  loadSearchPanel() {
    const slot = this.querySelector('[data-search-panel-slot]');
    if (!slot || slot.dataset.loaded === 'true') return;

    // Marked before the request so a second open while it is in flight does not
    // queue another injection.
    slot.dataset.loaded = 'true';
    fetchSearchPanel()
      .then((html) => {
        slot.innerHTML = html;
      })
      .catch((error) => {
        // An empty panel still leaves search itself working.
        slot.dataset.loaded = 'false';
        console.error('search panel failed to load', error);
      });
  }

  open(event) {
    this.loadSearchPanel();
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
